import React from 'react'
import Parser from 'html-react-parser'
import { Link } from 'react-router-dom'

global.isclient && require('./index.css')
const {rxconfig,changeColorSVG} = global.rootRequire('classes/ulti')

const SelectCustom = global.rootRequire('components/shares/rxSelectCustom').default

let adminCSS = '<style>.main-container{ width: 100% !important; padding: 0px !important; } .homenav, .footer{ display: none !important; }</style>'

export const renderBody = (vm) => <div>
  <div className='zlogin_form'>
    <div className='zlogin_head'>
      <img src={'./images/default/logo.svg'} alt='' className='zlogin_logo' style={{ height: '65px' }} />
    </div>
    <div className='zlogin_body'>

      <div className='zlogin_title'>
        Đăng nhập với Internal Operator
      </div>
      
      <div className='zlogin_row zformline'>
        <div className='zinput_label'>
          Tên đăng nhập
        </div>
        <div className='zinput_input'>
          <input className ='zinput_username' type='text' placeholder='Nhập tên đăng nhập' autoComplete='off' tabIndex='1' value={vm.state.inputUsername} onChange={(e) => vm.updateInput('inputUsername', e)} />
        </div>
      </div>

      <div className='zlogin_row zformline'>
        <div className='zinput_label'>
          Mật khẩu
        </div>
        <div className='zinput_input'>
          <input className ='zinput_password' type={(!vm.state.flagShowPass) ? 'password' : 'text' } placeholder='Nhập mật khẩu' autoComplete='off' tabIndex='2' value={vm.state.inputPass} onChange={(e) => vm.updateInput('inputPass', e)} />
          <span className='zicon_pass_display'>
            <img src={(!vm.state.flagShowPass) ? './images/default/icons/icon-pass-hide.png' : './images/default/icons/icon-pass-show.png'} alt='' onClick={e => vm.onClickDisplayPass()}/>  
          </span>
        </div>
      </div>

      <div className='zlogin_row'>
        <div className="zinput_savelogin">
          <input type="checkbox" id="checkbox" name="" value="" checked={vm.state.checkSaveLogin} onChange={e => {vm.changeCheckedSaveMe()}}/>
          <label htmlFor="checkbox">
            <span>Ghi nhớ trạng thái đăng nhập</span>
          </label>
        </div>
      </div>
      
      <div className='zlogin_errMess'>{vm.state.errMess}</div>
      <div className='zlogin_errMess'>{vm.state.errMessDesc}</div>
      <div className={(vm.state.inputUsername !== '' && vm.state.inputPass !== '' ) ? 'zlogin_btnlogin' : 'zlogin_btnlogin zlogin_btnlogin_noiput' }  tabIndex='3' onClick={e => vm.onClickLogin()}>Đăng nhập</div>
      
      <div className='zlogin_row zlogin_forgetpass_help'>
        <span className='zlogin_title_forgetpass' onClick={e => vm.openExternalLink('https://accounts.bobacu.io/forgot-password?')}>Quên mật khẩu</span> | <span onClick={e => vm.openExternalLink('https://support.bobacu.io/hc/vi')}>Trợ giúp</span>
      </div>
      <div className='zlogin_row zlogin_register'>
        <p className='authform__msg'>Bạn chưa có tài khoản? <Link to='/register'>Đăng ký tài khoản</Link></p>
      </div>
    </div>
  </div>
</div>

export const renderFoot = (vm) => <div className='zlogin_foot'>
  <div className='zlogin_foottext' />{{
    'default':<svg className='bg-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 810' preserveAspectRatio='xMinYMin slice'>
      <path id="svg_1" d="m592.66,0c-15,64.092 -30.7,125.285 -46.598,183.777c87.994,141.783 202.286,367.155 273.58,625.723l419.672,0c-54.796,-215.773 -156.19,-519.436 -336.677,-809.5l-309.977,0z" fill="#fde4d9"/>
      <path id="svg_2" d="m545.962,183.777c-53.796,196.576 -111.592,361.156 -163.49,490.74c11.7,44.494 22.8,89.49 33.1,134.883l404.07,0c-71.294,-258.468 -185.586,-483.84 -273.68,-625.623z" fill="#fff6f2"/>
      <path id="svg_3" d="m153.89,-1c74.094,180.678 161.088,417.448 228.483,674.517c67.297,-168.18 144.69,-395.052 210.187,-674.517l-438.67,0z" fill="#f9ede5"/>
      <path id="svg_4" d="m153.89,0l-153.89,0l0,809.5l415.57,0c-70.093,-308.562 -174.686,-597.626 -261.68,-809.5z" fill="#fff6f2"/>
      <path id="svg_5" d="m1144.22,501.538c52.596,-134.583 101.492,-290.964 134.09,-463.343c1.2,-6.1 2.3,-12.298 3.4,-18.497c0,-0.2 0.1,-0.4 0.1,-0.6c1.1,-6.3 2.3,-12.7 3.4,-19.098l-382.674,0c105.293,169.28 183.688,343.158 241.684,501.638l0,-0.1z" fill="#f9ede5"/>
      <path id="svg_6" d="m1285.31,0c-2.2,12.798 -4.5,25.597 -6.9,38.195c43.097,48.195 101.193,120.785 161.59,218.973l0,-257.168l-154.69,0z" fill="#fdf2ea"/>
      <path id="svg_7" d="m1278.31,38.196c-32.5,171.678 -81.09,327.36 -133.49,461.642l0,3.8c41,112.286 71.59,216.573 94.29,305.962l200.59,0.4l0,-553.232c-60.3,-97.988 -118.29,-170.48 -161.39,-218.573l0,0.001z" fill="#fff6f2"/>
    </svg>  
  }[rxconfig.theme]}  
</div>

export const renderComponent = (vm) => 
vm.state.loading ?
<div id ="loading"><div></div><div></div></div>
:
<div>
  
  <div className='zlogin-background'>
    <img src='./images/default/background/bg.jpg' srcSet='./images/default/background/bg.jpg, ./images/default/background/bg.jpg' />
  </div>
  <div className='zlogin-container'>
    <div className='zlogin-child'>
      <div className='zlogin_bg_opacity'>
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect opacity="0.8" rx="20" fill="#0866ff"/>
        </svg>
      </div>
      {Parser(adminCSS)}
      {vm.renderBody()}
      {/*{vm.renderFoot()}*/}
    </div>
  </div>
</div>

